/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Link_FaqInputs */

const en_dashboard_link_faq = /** @type {(inputs: Dashboard_Link_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link to FAQ`)
};

const fr_dashboard_link_faq = /** @type {(inputs: Dashboard_Link_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lien vers la FAQ`)
};

/**
* | output |
* | --- |
* | "Link to FAQ" |
*
* @param {Dashboard_Link_FaqInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const dashboard_link_faq = /** @type {((inputs?: Dashboard_Link_FaqInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Link_FaqInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_link_faq(inputs)
	return fr_dashboard_link_faq(inputs)
});